import React, { useState } from "react";

// Popup "🔤 Assegna sviluppo alle taglie" (vedi OrdiniMapping.jsx): per i
// file cliente che NON hanno affatto un "nome calzata" sorgente (nessuna
// colonna da abbinare — è lo strumento "🔤 Sviluppi" sull'intestazione che
// serve quando i valori grezzi ci sono ma vanno riconosciuti), qui invece si
// scrive direttamente lo sviluppo da usare, senza passare da un valore nel
// file: o lo stesso per tutte le taglie presenti, o uno diverso per ogni
// articolo (Riga_Articolo) in un colpo solo, invece di aprire ogni singola
// cella a mano.
export default function AssegnaSviluppoModal({
  sviluppi, gruppi, totaleRighe, puoCreareSviluppi, onApplicaTutte, onApplicaPerGruppo, onCreaSviluppo, onChiudi,
}) {
  const [modo, setModo] = useState("tutte"); // "tutte" | "perGruppo"
  const [valoreUnico, setValoreUnico] = useState("");
  const [perGruppo, setPerGruppo] = useState({}); // { chiaveGruppo: sviluppo }
  const [nuovoSviluppo, setNuovoSviluppo] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [errore, setErrore] = useState("");

  const gruppiCompilati = gruppi.filter((g) => perGruppo[g.chiave]);

  // Solo per wtrendy (vedi puoCreareSviluppi): può capitare che l'azienda
  // scelta non abbia ANCORA nessuno sviluppo caricato — è spesso proprio
  // lui a preparare il primissimo mapping di un cliente — quindi deve poter
  // aggiungerne uno al volo da qui, senza dover aprire Impostazioni prima.
  async function aggiungiSviluppo() {
    const testo = nuovoSviluppo.trim();
    if (!testo) return;
    setErrore("");
    setSalvando(true);
    try {
      await onCreaSviluppo(testo);
      setNuovoSviluppo("");
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function applicaTutte() {
    if (!valoreUnico) return;
    setErrore("");
    setSalvando(true);
    try {
      await onApplicaTutte(valoreUnico);
      onChiudi();
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  async function applicaPerGruppo() {
    if (gruppiCompilati.length === 0) return;
    setErrore("");
    setSalvando(true);
    try {
      const assegnazioni = {};
      for (const g of gruppiCompilati) assegnazioni[g.chiave] = perGruppo[g.chiave];
      await onApplicaPerGruppo(assegnazioni);
      onChiudi();
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "640px", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>🔤</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Assegna sviluppo alle taglie
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {totaleRighe} taglie in anteprima
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          {errore && <p className="errore" style={{ marginTop: 0 }}>{errore}</p>}

          {puoCreareSviluppi && (
            <div className="riga-controlli" style={{ marginBottom: "16px", paddingBottom: "14px", borderBottom: "1px solid var(--cf-border)" }}>
              <input
                type="text"
                placeholder="nuovo sviluppo per questa azienda..."
                value={nuovoSviluppo}
                onChange={(e) => setNuovoSviluppo(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") aggiungiSviluppo(); }}
                disabled={salvando}
              />
              <button onClick={aggiungiSviluppo} disabled={salvando || !nuovoSviluppo.trim()}>
                + aggiungi al vocabolario
              </button>
            </div>
          )}

          {sviluppi.length === 0 ? (
            <p className="testo-secondario" style={{ marginTop: 0 }}>
              {puoCreareSviluppi
                ? "Nessuno sviluppo caricato ancora per questa azienda: aggiungine uno qui sopra per iniziare."
                : "Nessuno sviluppo ancora caricato per la tua azienda: chiedi a wtrendy di popolare l'elenco dal pannello Impostazioni prima di poter assegnare i valori qui sotto."}
            </p>
          ) : (
            <>
              <div style={{ display: "flex", gap: "8px", marginBottom: "18px" }}>
                <button
                  onClick={() => setModo("tutte")}
                  style={modo === "tutte" ? { backgroundColor: "#1e3a8a", color: "#fff", borderColor: "#1e3a8a" } : undefined}
                >
                  Stesso sviluppo per tutte
                </button>
                <button
                  onClick={() => setModo("perGruppo")}
                  disabled={gruppi.length === 0}
                  title={gruppi.length === 0 ? "Serve almeno Riga_Articolo mappato per distinguere gli articoli" : undefined}
                  style={modo === "perGruppo" ? { backgroundColor: "#1e3a8a", color: "#fff", borderColor: "#1e3a8a" } : undefined}
                >
                  Uno sviluppo diverso per articolo ({gruppi.length})
                </button>
              </div>

              {modo === "tutte" ? (
                <>
                  <p className="testo-secondario" style={{ marginTop: 0 }}>
                    Scrive lo stesso sviluppo su tutte le {totaleRighe} taglie in anteprima, sostituendo quello che
                    c'era prima in questa colonna.
                  </p>
                  <div className="riga-controlli">
                    <select value={valoreUnico} onChange={(e) => setValoreUnico(e.target.value)} style={{ minWidth: "14rem" }}>
                      <option value="">-- scegli sviluppo --</option>
                      {sviluppi.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                    <button className="btn-primario" onClick={applicaTutte} disabled={salvando || !valoreUnico}>
                      {salvando ? "Applicazione..." : `Applica a tutte (${totaleRighe})`}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <p className="testo-secondario" style={{ marginTop: 0 }}>
                    Uno sviluppo per ciascun Riga_Articolo presente — si applica a tutte le taglie di quell'articolo.
                    Lascia vuoti quelli che non vuoi toccare.
                  </p>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "14px" }}>
                    {gruppi.map((g) => (
                      <div key={g.chiave} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 10px", borderRadius: "8px", backgroundColor: "var(--cf-bg-subtle)", border: "1px solid var(--cf-border)" }}>
                        <span style={{ flex: "1 1 auto", fontSize: "13px", wordBreak: "break-word" }} title={g.etichetta}>
                          {g.etichetta} <span className="testo-secondario">({g.numeroTaglie} taglie)</span>
                        </span>
                        <span style={{ color: "var(--cf-text-faint)" }}>→</span>
                        <select
                          value={perGruppo[g.chiave] || ""}
                          onChange={(e) => setPerGruppo((prev) => ({ ...prev, [g.chiave]: e.target.value }))}
                          style={{ minWidth: "12rem" }}
                        >
                          <option value="">-- scegli sviluppo --</option>
                          {sviluppi.map((s) => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                    ))}
                  </div>
                  <button className="btn-primario" onClick={applicaPerGruppo} disabled={salvando || gruppiCompilati.length === 0}>
                    {salvando ? "Applicazione..." : `Applica (${gruppiCompilati.length}/${gruppi.length} articoli)`}
                  </button>
                </>
              )}
            </>
          )}
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button onClick={onChiudi}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}
